import {IconSizeProps} from "./types";

export default function SOLDarkIcon({ size=40,...props}: IconSizeProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.1242 24.7415C12.265 24.6007 12.4586 24.5186 12.6639 24.5186H31.2841C31.6243 24.5186 31.7945 24.9292 31.5539 25.1697L27.8757 28.848C27.7349 28.9888 27.5413 29.0709 27.3359 29.0709H8.71576C8.3755 29.0709 8.20537 28.6603 8.4459 28.4198L12.1242 24.7415Z"
            fill="black"/>
        <path
            d="M12.1243 11.0081C12.271 10.8673 12.4646 10.7852 12.664 10.7852H31.2842C31.6245 10.7852 31.7946 11.1958 31.5541 11.4363L27.8758 15.1146C27.735 15.2554 27.5414 15.3375 27.3361 15.3375H8.71588C8.37562 15.3375 8.20549 14.9269 8.44602 14.6864L12.1243 11.0081Z"
            fill="black"/>
        <path
            d="M27.8757 17.8299C27.7349 17.6891 27.5413 17.6069 27.3359 17.6069H8.71576C8.3755 17.6069 8.20537 18.0176 8.4459 18.2581L12.1242 21.9364C12.265 22.0772 12.4586 22.1593 12.6639 22.1593H31.2841C31.6243 22.1593 31.7945 21.7487 31.5539 21.5081L27.8757 17.8299Z"
            fill="black"/>
    </svg>

}